import {
  SchemaDefinition,
  SchemaTransformError,
  UnknownSchema,
  ViewModel
} from '@rehaje/core'

import type { PageSpecific } from './TypedNode'

export interface SchemaPageSpecific extends RehajeSchemaMetadata {
  /**
   * 页面默认配置
   */
  default?: PageSpecific
  type: 'Schema.Page'
  /**
   * 值
   */
  value?: any
}

export class SchemaPageDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaPageSpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaPageSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(target: any, schema?: SchemaPageSpecific): SchemaPageSpecific {
    if (schema) return { ...schema, type: 'Schema.Page', value: target }
    return { type: 'Schema.Page', value: target }
  }

  override inferTypeScript(schema: SchemaPageSpecific): string {
    if (schema.value instanceof ViewModel)
      return super.inferShapeTypeScript(schema.value)
    return this.interface
  }

  override prune(target: any): any {
    return target
  }

  override transform(
    target: any,
    schema: SchemaPageSpecific,
    path: PropertyKey[] = []
  ) {
    if (this.test(target, schema, path)) return target
    if (target !== schema.fallback)
      this.raise(new SchemaTransformError(schema.name))
    return target
  }

  override validate(target: any, schema: SchemaPageSpecific) {
    this.validateMetadata(target, schema, (target) => {
      return typeof target === 'function' || this.isRelationSpecific(target)
    })
  }
}

declare global {
  export interface RehajeSpecifics {
    'Schema.Page': SchemaPageSpecific
  }
}
